import { useMemo } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useFormatter } from 'js/hooks/useFormatter';
import { parseDate } from 'js/hooks/useFormatter/helpers';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { formatLoginLimit } from '../helpers';
import { useDynamicReducerSelector } from '../store';
import { LIMIT_TYPES, UNLIMITED_DATE_VALUE, UNLIMITED_VALUES } from '../constants';

export const useGetLimits = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const limits = useDynamicReducerSelector(prop('limits'));

    return useMemo(() => limits.map(data => {
        const { type, period, limit, products } = data;
        const isUnlimited = UNLIMITED_VALUES.includes(limit);
        const item = { ...data };
        const isDateUnlimited = UNLIMITED_DATE_VALUE <= parseDate(item.endDate).getFullYear();

        item.type = type && translate(`filter.limitType.${type}`);
        item.period = period && translate(`filter.limitPeriod.${period}`);
        item.startDate = item.startDate && formatter.getDateTimeShort(formatter.parseImsDate(item.startDate));
        item.endDate = item.endDate && formatter.getDateTimeShort(formatter.parseImsDate(item.endDate));

        if (isDateUnlimited) {
            item.endDate = translate('table.unlimited');
        }

        if (isUnlimited) {
            item.limit = translate('table.unlimited');
        }

        if (products) {
            item.products = products.join(', ');
        }

        switch (type) {
            case LIMIT_TYPES.DEPOSIT:
            case LIMIT_TYPES.BET:
            case LIMIT_TYPES.LOSS:
            case LIMIT_TYPES.WITHDRAW:
            case LIMIT_TYPES.MIN_BALANCE:
            case LIMIT_TYPES.PRODUCT_LOSS:
            case LIMIT_TYPES.PRODUCT_BET:
            case LIMIT_TYPES.SINGLE_BET_LIMIT:
                if (!isUnlimited) {
                    item.limit = formatter.formatCurrency(limit);
                }

                break;
            case LIMIT_TYPES.SESSION_TIMER:
            case LIMIT_TYPES.REALITY_CHECK:
                if (!isUnlimited) {
                    item.limit = `${limit} ${translate('table.limit.minutes')}`;
                }

                break;
            case LIMIT_TYPES.LOGIN_PERIOD:
                if (!isUnlimited) {
                    item.limit = formatLoginLimit(limit, translate);
                }

                break;
            default:
                break;
        }

        return item;
    }), [limits, translate, formatter]);
};
